import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Phone, ArrowLeft } from "lucide-react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { RecentJobs } from "@/components/RecentJobs";
import { Pricing } from "@/components/Pricing";
import { Vision } from "@/components/Vision";
import { FreeEstimate } from "@/components/FreeEstimate";
import { Footer } from "@/components/Footer";
import { Admin } from "@/components/Admin";
import { CONTACT } from "@/data";

const FloatingCall = () => (
  <a
    href={CONTACT.phoneRaw}
    data-testid="floating-call-button"
    className="md:hidden fixed bottom-5 inset-x-5 z-50 inline-flex items-center justify-center gap-2 rounded-full bg-brand-olive px-6 py-4 font-semibold text-brand-bg shadow-[0_10px_30px_rgba(74,53,40,0.3)]"
  >
    <Phone size={18} /> Call {CONTACT.phoneDisplay}
  </a>
);

const BackHome = ({ onDark }) => (
  <a
    href="/"
    data-testid="back-home-button"
    className={`fixed top-[84px] left-4 sm:left-6 z-40 inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold shadow-lg transition-transform hover:-translate-x-0.5 ${
      onDark ? "bg-[#FCFAF6] text-brand-brown" : "bg-brand-brown text-brand-bg"
    }`}
  >
    <ArrowLeft size={16} /> Home
  </a>
);

const Home = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [hash]);

  return (
    <div className="bg-brand-bg font-body text-brand-ink antialiased">
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyChooseUs />
        <Vision />
        <FreeEstimate />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
};

const RecentJobsPage = () => {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="bg-brand-bg font-body text-brand-ink antialiased">
      <Header />
      <BackHome onDark={false} />
      <main className="pt-[72px]">
        <RecentJobs />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
};

const PricingPage = () => (
  <div className="bg-brand-brown font-body text-brand-ink antialiased">
    <Header />
    <BackHome onDark={true} />
    <main>
      <Pricing />
    </main>
    <Footer />
    <FloatingCall />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/recent-jobs" element={<RecentJobsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/alldone0491" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
